import { productActivationResource } from '@townsquare/product-activation-check/resource';
import { createGlobalRoute } from '@townsquare/router/create-route';

import { farewellFeedResource } from './resources/farewell-feed-resource';
import { loomFeedResource } from './resources/loom-feed-resource';
import { popularFeedResource } from './resources/popular-feed-resource';
import { welcomeFeedResource } from './resources/welcome-feed-resource';

export const discoverRouteDefinition = createGlobalRoute({
	exact: true,
	name: 'discover',
	path: '/discover',
	layout: 'home',
	resources: [
		productActivationResource,
		loomFeedResource,
		popularFeedResource,
		welcomeFeedResource,
		farewellFeedResource,
	],
});
